import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { Box } from "@material-ui/core";

import { trackPageView } from "@ip-utils";

import ErrorBoundary from "./ErrorBoundary";
import VersionCheck from "./VersionCheck";

type Props = {
  children: React.ReactNode;
};

export default function Layout({ children }: Props) {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return (
    <ErrorBoundary>
      <Box display="flex" flexDirection="column" minHeight="100vh">
        <VersionCheck />
        {children}
      </Box>
    </ErrorBoundary>
  );
}
